import { Container, Square } from '@grubhubprod/gh-cookbook-react/dist';
import classnames from 'classnames';
import React, { ReactNode } from 'react';
import { Helmet } from 'react-helmet-async';
import Navigation from 'src/components/enterprise/navigation/Navigation';
import Header from 'src/components/Header/Header';
import { getConfig } from 'src/utilities/config';

interface IEnterpriseLayoutProps {
  children: ReactNode;
  hideNavigationMenu?: boolean;
  pageTitle: string;
  useFluidContainer?: boolean;
}

export default function EnterpriseLayout({
  children,
  hideNavigationMenu = false,
  pageTitle,
  useFluidContainer,
}: IEnterpriseLayoutProps): JSX.Element {
  const {
    site: { enterpriseTitle },
  } = getConfig();

  return (
    <>
      <Helmet defer={false}>
        <title>
          {`${enterpriseTitle} ${pageTitle ? ` | ${pageTitle}` : ''}`}
        </title>
      </Helmet>
      <Header />

      <Navigation hideMenu={hideNavigationMenu} />

      <main role="main">
        <Square
          bg="backgroundTint"
          paddingBottom="12"
          className={classnames(
            'enterpriseLayout_content',
            'enterpriseLayout_contentTopOffset'
          )}
        >
          <Container variant={useFluidContainer ? 'fluid' : 'default'}>
            {children}
          </Container>
        </Square>
      </main>
    </>
  );
}
